import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/cakesAndBakes"

const CakesAndBakes = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default CakesAndBakes

export const query = graphql`
  query CakesAndBakesCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/cakesAndBakes-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
